<template>
  <div style="display: inline-block">
    <v-btn
      v-if="livechat"
      color="primary"
      outline
      fab
      :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
      small
      @click.stop="openModal"
    >
      <v-icon>edit</v-icon>
    </v-btn>
    <template v-if="type == 'add'">
      <v-chip
        v-if="isquickaddticket"
        small
        color="primary"
        dark
        class="caption"
        :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
        @click="openModal"
      >
        <v-icon>add</v-icon>Add Ticket
      </v-chip>
      <v-btn
        v-else
        color="primary"
        outline
        :loading="loadingAgentGroup || loadingAgentSubGroup || loading"
        @click="openModal"
        ><v-icon>add</v-icon>Add</v-btn
      >
    </template>

    <v-dialog v-model="showManage" persistent max-width="600">
      <v-card v-if="!loadingAgentGroup && !loadingAgentSubGroup && showManage">
        <v-layout>
          <v-flex class="pl-4 pt-3">
            <h3 class="title">{{ type == 'add' ? 'Add' : 'Edit' }} Ticket</h3>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-btn small fab flat :loading="loading || loadingTicket" @click="onCancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-card-text>
          <v-layout
            v-if="type != 'add' && nextCapitalPage.includes(selectedBot.pageid)"
            class="mb-4"
          >
            <v-flex xs6 sm6 class="mr-2">
              <v-btn
                :color="selectedMenu == 'ticketInfo' ? 'primary' : 'gray'"
                block
                large
                @click="selectedMenu = 'ticketInfo'"
                >Ticket Information</v-btn
              >
            </v-flex>
            <v-flex xs6 sm6>
              <v-btn
                :color="selectedMenu != 'ticketInfo' ? 'primary' : 'gray'"
                block
                large
                @click="selectedAgentApprove"
                >Agent Approve</v-btn
              >
            </v-flex>
          </v-layout>

          <div v-if="selectedMenu == 'ticketInfo'">
            <v-layout wrap>
              <v-flex v-if="type == 'add'" xs12 sm12>
                <div class="text-xs-right">
                  <v-autocomplete
                    v-model="select"
                    return-object
                    label="Find customer"
                    solo
                    :loading="loading"
                    :items="items"
                    :search-input.sync="search"
                    outline
                    prepend-inner-icon="search"
                    :item-text="getFullName"
                    :item-value="'id'"
                    class="default-input-textfield"
                    @change="onChangeSelect"
                  >
                    <template #item="data">
                      <template v-if="!checkType(typeof data.item, 'object')">
                        <v-list-tile-content
                          v-text="data.item.first_name + ' ' + data.item.last_name"
                        ></v-list-tile-content>
                      </template>
                      <template v-else>
                        <v-list-tile-avatar>
                          <img v-if="data.item.profile_pic" :src="data.item.profile_pic" />
                          <img v-else :src="'/static/img/assets/livechat/profile.png'" />
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="data.item.first_name + ' ' + data.item.last_name"
                          ></v-list-tile-title>
                          <v-list-tile-sub-title v-html="data.item.app"></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </template>
                    </template>

                    <template #append-outer>
                      <v-icon
                        :key="`icon-delete`"
                        :disabled="!select"
                        @click="onClearCustomer"
                        v-text="'delete'"
                      ></v-icon>
                    </template>
                  </v-autocomplete>
                </div>
              </v-flex>
              <template v-if="!livechat">
                <v-flex
                  xs12
                  sm6
                  class="form-control px-1"
                  :class="{ 'has-error': errors.has('firstname') }"
                >
                  <div class="caption mb-1 mt-2">Customer First Name *</div>
                  <div
                    v-if="['facebook', 'line'].includes(ticket.channel)"
                    class="primary--text mb-3"
                  >
                    {{ ticket.firstname }}
                  </div>
                  <template v-else>
                    <input
                      v-model="ticket.firstname"
                      v-validate="'required'"
                      type="text"
                      :placeholder="$t('customer first name')"
                      class="form-control"
                      maxlength="255"
                      :data-vv-as="$t('Customer First Name')"
                      name="firstname"
                    />
                  </template>
                  <p v-if="errors.has('firstname')" class="text-error">
                    {{ errors.first('firstname') }}
                  </p>
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1">
                  <div class="caption mb-1 mt-2">Customer Last Name</div>
                  <div
                    v-if="['facebook', 'line'].includes(ticket.channel)"
                    class="primary--text mb-3"
                  >
                    {{ ticket.lastname }}
                  </div>
                  <template v-else>
                    <input
                      v-model="ticket.lastname"
                      type="text"
                      :placeholder="$t('customer last name')"
                      class="form-control"
                      maxlength="255"
                    />
                  </template>
                </v-flex>

                <v-flex xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Gender</div>
                  <v-autocomplete
                    v-model="ticket.gender"
                    name="gender"
                    :loading="loading"
                    :items="genderOptions"
                    outline
                    clearable
                    class="default-input-textfield"
                    single-line
                    :hide-details="!errors.has('gender')"
                    :error="errors.has('gender')"
                    :error-messages="errors.first('gender')"
                    placeholder="Gender"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1">
                  <div class="caption mb-1 mt-2">Email</div>
                  <input
                    v-model="ticket.email"
                    type="text"
                    :placeholder="$t('Email')"
                    class="form-control"
                    maxlength="255"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1">
                  <div class="caption mb-1 mt-2">Phone No</div>
                  <input
                    v-model="ticket.phoneno"
                    type="number"
                    :placeholder="$t('Phone No')"
                    class="form-control"
                    maxlength="255"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1">
                  <div class="caption mb-1 mt-2">App</div>
                  <div v-if="ticket.userid" class="primary--text mb-3">
                    {{ ticket.app }}
                  </div>
                  <v-autocomplete
                    v-else
                    v-model="ticket.app"
                    name="app"
                    :loading="loading"
                    :items="appOptions"
                    outline
                    clearable
                    class="default-input-textfield"
                    single-line
                    :hide-details="!errors.has('app')"
                    :error="errors.has('app')"
                    :error-messages="errors.first('app')"
                    placeholder="App"
                  />
                </v-flex>
                <v-flex xs12 class="form-control px-1">
                  <div class="caption mb-1 mt-2">Address</div>
                  <textarea
                    id="address"
                    v-model="ticket.address"
                    name="address"
                    style="width: 100%; min-height: 100px"
                    :data-vv-as="$t('Address')"
                    class="form-control"
                    :placeholder="$t('Address')"
                  ></textarea>
                </v-flex>
                <v-flex xs12>
                  <v-divider class="my-3" />
                </v-flex>
              </template>
              <template
                v-if="
                  ($store.state.privilege && $store.state.privilege.assign_ticket) ||
                  ['seagull'].includes(selectedBot.theme)
                "
              >
                <v-flex
                  xs12
                  sm6
                  class="form-control px-1 pb-2"
                  :class="{ 'has-error': errors.has('group') }"
                >
                  <div class="caption mb-1 mt-2">Group *</div>
                  <v-autocomplete
                    v-model="ticket.group"
                    v-validate="'required'"
                    return-object
                    name="group"
                    :loading="loading"
                    :items="agentGroup"
                    outline
                    clearable
                    :item-text="'groupname'"
                    :item-value="'groupname'"
                    class="default-input-textfield"
                    single-line
                    :hide-details="!errors.has('group')"
                    :error="errors.has('group')"
                    :error-messages="errors.first('group')"
                    :placeholder="$t('Group')"
                    @change="onChangeGroup"
                  />
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Subgroup</div>
                  <v-autocomplete
                    v-model="ticket.subgroup"
                    return-object
                    name="subgroup"
                    :loading="loading"
                    :items="filterSubGroup"
                    outline
                    clearable
                    :item-text="'subgroupname'"
                    :item-value="'subgroupname'"
                    class="default-input-textfield"
                    single-line
                    :hide-details="!errors.has('subgroup')"
                    :error="errors.has('subgroup')"
                    :error-messages="errors.first('subgroup')"
                    :placeholder="$t('Sub Group')"
                    @change="onChangeSubGroup"
                  />
                </v-flex>
                <v-flex xs12 sm12 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Assigned to</div>
                  <v-autocomplete
                    v-model="ticket.assignedTo"
                    return-object
                    name="assignedTo"
                    :loading="loading"
                    :items="filterAgents"
                    outline
                    clearable
                    :item-text="'name'"
                    :item-value="'name'"
                    class="default-input-textfield"
                    single-line
                    :hide-details="!errors.has('assignedTo')"
                    :error="errors.has('assignedTo')"
                    :error-messages="errors.first('assignedTo')"
                    :placeholder="$t('Assigned To')"
                  />
                </v-flex>
              </template>
              <template v-else>
                <v-flex v-if="ticket.group" xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Group *</div>
                  {{ ticket.group.groupname }}
                </v-flex>
                <v-flex v-if="ticket.subgroup" xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Subgroup</div>
                  {{ ticket.subgroup.subgroupname }}
                </v-flex>
                <v-flex v-if="ticket.assignedTo" xs12 sm6 class="form-control px-1 pb-2">
                  <div class="caption mb-1 mt-2">Assigned to</div>
                  {{ ticket.assignedTo.name }}
                </v-flex>
              </template>

              <v-flex
                xs12
                class="form-control px-1"
                :class="{ 'has-error': errors.has('subject') }"
              >
                <div class="caption mb-1 mt-2">Subject *</div>
                <input
                  v-model="ticket.subject"
                  v-validate="'required'"
                  type="text"
                  :placeholder="$t('Subject')"
                  class="form-control"
                  maxlength="255"
                  :data-vv-as="$t('Subject')"
                  name="subject"
                />
                <p v-if="errors.has('subject')" class="text-error">{{ errors.first('subject') }}</p>
              </v-flex>
              <v-flex
                xs12
                class="form-control px-1"
                :class="{ 'has-error': errors.has('details') }"
              >
                <div class="caption mb-1 mt-2">Details *</div>
                <textarea
                  id="details"
                  v-model="ticket.details"
                  v-validate="'required'"
                  name="details"
                  style="width: 100%; min-height: 70px"
                  :data-vv-as="$t('Details')"
                  class="form-control"
                  :placeholder="$t('Details')"
                ></textarea>
                <p v-if="errors.has('details')" class="text-error">{{ errors.first('details') }}</p>
              </v-flex>

              <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
                <v-expansion-panel class="mb-3">
                  <v-expansion-panel-content>
                    <template #actions>
                      <v-icon color="primary">$vuetify.icons.expand</v-icon>
                    </template>
                    <template #header>
                      <div>{{ $t('additional_information') }}</div>
                    </template>
                    <v-card class="pa-2">
                      <v-layout wrap>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Real Firstname</div>
                          <template>
                            <input
                              v-model="ticket.contact_firstname"
                              type="text"
                              :placeholder="$t('Real Firstname')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Real Surname</div>

                          <template>
                            <input
                              v-model="ticket.contact_lastname"
                              type="text"
                              :placeholder="$t('Real Surname')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Salary Range</div>
                          <template>
                            <input
                              v-model="ticket.contact_salary"
                              type="text"
                              :placeholder="$t('Salary Range')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Occupation</div>
                          <template>
                            <input
                              v-model="ticket.contact_occupation"
                              type="text"
                              :placeholder="$t('Occupation')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Phone number for Ticket</div>
                          <template>
                            <input
                              v-model="ticket.contact_phone"
                              type="number"
                              :placeholder="$t('Phone number for Ticket')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                        <v-flex xs12 sm6 class="form-control px-1">
                          <div class="caption mb-1 mt-2">Email for Ticket</div>
                          <template>
                            <input
                              v-model="ticket.contact_email"
                              type="text"
                              :placeholder="$t('Email for Ticket')"
                              class="form-control"
                              maxlength="255"
                            />
                          </template>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </template>
              <template v-else>
                <template
                  v-if="
                    !['nt'].includes(selectedBot.type) && !['seagull'].includes(selectedBot.theme)
                  "
                >
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Real Firstname</div>
                    <template>
                      <input
                        v-model="ticket.contact_firstname"
                        type="text"
                        :placeholder="$t('Real Firstname')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Real Surname</div>

                    <template>
                      <input
                        v-model="ticket.contact_lastname"
                        type="text"
                        :placeholder="$t('Real Surname')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Salary Range</div>
                    <template>
                      <input
                        v-model="ticket.contact_salary"
                        type="text"
                        :placeholder="$t('Salary Range')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Occupation</div>
                    <template>
                      <input
                        v-model="ticket.contact_occupation"
                        type="text"
                        :placeholder="$t('Occupation')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Phone number for Ticket</div>
                    <template>
                      <input
                        v-model="ticket.contact_phone"
                        type="number"
                        :placeholder="$t('Phone number for Ticket')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                  <v-flex xs12 sm6 class="form-control px-1">
                    <div class="caption mb-1 mt-2">Email for Ticket</div>
                    <template>
                      <input
                        v-model="ticket.contact_email"
                        type="text"
                        :placeholder="$t('Email for Ticket')"
                        class="form-control"
                        maxlength="255"
                      />
                    </template>
                  </v-flex>
                </template>
              </template>
              <template
                v-if="
                  $store.state.kfcpage.includes(selectedBot.pageid) ||
                  $store.state.oceanlifePage.includes(selectedBot.pageid)
                "
              >
                <v-flex
                  v-if="$store.state.kfcpage.includes(selectedBot.pageid)"
                  xs12
                  sm6
                  class="form-control px-1"
                  :class="{ 'has-error': errors.has('totalPurchase') }"
                >
                  <div class="caption mb-1 mt-2">Total Purchase</div>
                  <input
                    v-model="ticket.kfc_order_amount"
                    type="number"
                    :placeholder="$t('Total Purchase')"
                    class="form-control"
                    maxlength="255"
                    :data-vv-as="$t('totalPurchase')"
                    name="totalPurchase"
                  />
                  <!-- v-validate="'required'" -->
                  <p v-if="errors.has('subject')" class="text-error">
                    {{ errors.first('totalPurchase') }}
                  </p>
                </v-flex>
                <v-flex xs12 sm6 class="form-control px-1">
                  <div class="caption mb-1 mt-2">คะแนนความพึงพอใจ</div>
                  <input
                    v-model="ticket.satisfaction_score"
                    type="text"
                    placeholder="คะแนนความพึงพอใจ"
                    class="form-control"
                    maxlength="255"
                    name="satisfaction_score"
                    readonly
                  />
                </v-flex>
                <v-flex
                  v-if="$store.state.oceanlifePage.includes(selectedBot.pageid)"
                  xs12
                  sm6
                  class="form-control px-1"
                >
                  <div class="caption mb-1 mt-2">คะแนนในการแนะนำบริการ</div>
                  <input
                    v-model="ticket.recommendation_score"
                    type="text"
                    placeholder="คะแนนในการแนะนำบริการ"
                    class="form-control"
                    maxlength="255"
                    name="recommendation_score"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 class="form-control px-1">
                  <div class="caption mb-1 mt-2">ข้อเสนอแนะ</div>
                  <textarea
                    id="suggestion_note "
                    v-model="ticket.suggestion_note"
                    name="suggestion_note "
                    style="width: 100%; min-height: 100px"
                    class="form-control"
                    placeholder="ข้อเสนอแนะ"
                    readonly
                  ></textarea>
                </v-flex>
              </template>

              <v-flex xs12 sm6>
                <div class="caption mb-1 mt-2">Priority *</div>
                <v-autocomplete
                  v-model="priority"
                  v-validate="'required'"
                  return-object
                  name="priority"
                  :loading="loading"
                  :items="priorityOptions"
                  outline
                  clearable
                  :item-text="'text'"
                  :item-value="'value'"
                  class="default-input-textfield"
                  single-line
                  :hide-details="!errors.has('priority')"
                  :error="errors.has('priority')"
                  :error-messages="errors.first('priority')"
                  placeholder="Priority"
                />
              </v-flex>

              <v-flex
                xs12
                sm6
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('status') }"
              >
                <div class="caption mb-1 mt-2">Status *</div>
                <v-autocomplete
                  v-if="selectedBot.theme == 'seagull'"
                  v-model="ticket.status"
                  v-validate="'required'"
                  item-text="name"
                  name="status"
                  :loading="loading"
                  :items="statusOptions"
                  outline
                  clearable
                  class="default-input-textfield"
                  single-line
                  :hide-details="!errors.has('status')"
                  :error="errors.has('status')"
                  :error-messages="errors.first('status')"
                  placeholder="Status"
                  @update:modelValue="changeStatus"
                />
                <v-autocomplete
                  v-else
                  v-model="ticket.status"
                  v-validate="'required'"
                  name="status"
                  :loading="loading"
                  :items="statusOptions"
                  outline
                  clearable
                  class="default-input-textfield"
                  single-line
                  :hide-details="!errors.has('status')"
                  :error="errors.has('status')"
                  :error-messages="errors.first('status')"
                  placeholder="Status"
                  @update:modelValue="changeStatus"
                  @input="changeStatus"
                />
              </v-flex>
              <v-flex
                v-if="
                  isJuzmatchCrm &&
                  ticket.status &&
                  ticket.status == 'closed' &&
                  currentStatus !== 'closed'
                "
                xs12
              >
                <div class="caption mb-1 mt-2">ต้องการปิดแบบส่งแบบประเมินหรือไม่ ? *</div>
                <v-radio-group
                  v-model="ticket.is_send_survey"
                  v-validate="'required'"
                  d-inline
                  row
                  :data-vv-as="$t('Survey')"
                  name="survey"
                >
                  <v-radio
                    class="mb-2"
                    :value="false"
                    color="primary"
                    label="ไม่ส่งแบบประเมิน"
                  ></v-radio>
                  <v-radio
                    class="mb-2"
                    :value="true"
                    color="primary"
                    label="ส่งแบบประเมิน"
                  ></v-radio>
                </v-radio-group>
                <p v-if="errors.has('survey')" class="text-error">{{ errors.first('survey') }}</p>
              </v-flex>

              <v-flex
                v-if="!isquickaddticket"
                xs12
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('channel') }"
              >
                <div class="caption mb-1 mt-2">Channel *</div>

                <v-radio-group
                  v-model="ticket.channel"
                  v-validate="'required'"
                  d-inline
                  row
                  :data-vv-as="$t('Channel')"
                  name="channel"
                >
                  <v-radio
                    class="mb-2"
                    :value="'facebook'"
                    color="primary"
                    label="facebook"
                  ></v-radio>
                  <v-radio class="mb-2" :value="'line'" color="primary" label="line"></v-radio>
                  <v-radio class="mb-2" :value="'phone'" color="primary" label="phone"></v-radio>
                  <v-radio class="mb-2" :value="'email'" color="primary" label="email"></v-radio>
                  <v-radio
                    class="mb-2"
                    :value="'website'"
                    color="primary"
                    label="website"
                  ></v-radio>
                  <v-radio class="mb-2" :value="'others'" color="primary" label="others"></v-radio>
                </v-radio-group>
                <p v-if="errors.has('channel')" class="text-error">{{ errors.first('channel') }}</p>
              </v-flex>
              <v-flex
                v-else
                xs12
                class="form-control px-1 pb-2"
                :class="{ 'has-error': errors.has('channel') }"
              >
                <div class="caption mb-1 mt-2">Channel *</div>

                <v-radio-group
                  v-model="ticket.channel"
                  v-validate="'required'"
                  d-inline
                  row
                  :data-vv-as="$t('Channel')"
                  name="channel"
                >
                  <v-radio
                    class="mb-2"
                    :value="'facebook'"
                    color="primary"
                    label="facebook"
                  ></v-radio>
                </v-radio-group>
                <p v-if="errors.has('channel')" class="text-error">{{ errors.first('channel') }}</p>
              </v-flex>

              <v-flex xs12>
                <div class="caption mb-1 mt-2">Tags</div>
                <v-combobox
                  v-model="tags"
                  :filter="tagsfilter"
                  :hide-no-data="!tagssearch"
                  :items="tagitems"
                  :search-input.sync="tagssearch"
                  hide-selected
                  label="Search for an option"
                  multiple
                  small-chips
                  solo
                >
                  <template #no-data>
                    <v-list-tile>
                      <span class="subheading">Create</span>
                      <v-chip :color="`primary lighten-3`" label small>{{ tagssearch }}</v-chip>
                    </v-list-tile>
                  </template>
                  <template #selection="{ item, parent, selected }">
                    <v-chip
                      v-if="item === Object(item)"
                      :color="`primary lighten-3`"
                      :selected="selected"
                      label
                      small
                    >
                      <span class="pr-2">{{ item.text }}</span>
                      <v-icon small @click="parent.selectItem(item)">close</v-icon>
                    </v-chip>
                  </template>
                  <template #item="{ index, item }">
                    <v-list-tile-content>
                      <v-text-field
                        v-if="tagediting === item"
                        v-model="tagediting.text"
                        autofocus
                        flat
                        background-color="transparent"
                        hide-details
                        solo
                        @keyup.enter="tagsedit(index, item)"
                      ></v-text-field>
                      <v-chip v-else :color="`primary lighten-3`" label small>{{
                        item.text
                      }}</v-chip>
                    </v-list-tile-content>
                    <v-spacer></v-spacer>
                    <v-list-tile-action @click.stop>
                      <v-btn icon @click.stop.prevent="tagsedit(index, item)">
                        <v-icon>{{ tagediting !== item ? 'edit' : 'check' }}</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </template>
                </v-combobox>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <template v-if="!['nt'].includes(selectedBot.type)">
                <v-flex xs12 sm7 class="px-1 form-control">
                  <div class="caption">Due Date</div>
                  <datepicker
                    v-model="duedate.start"
                    color="primary"
                    @selected="onSelectedDueDate"
                  ></datepicker>
                </v-flex>
                <v-flex xs6 sm4 class="px-1 form-control">
                  <div class="caption">Time</div>

                  <v-dialog
                    ref="starttime"
                    v-model="showDueTimeDialog"
                    :return-value.sync="duedate.starttime"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template #activator="{ on }">
                      <v-layout>
                        <input
                          v-model="duedate.starttime"
                          type="text"
                          readonly
                          placeholder="00:00"
                          :disabled="duedate.start == null"
                          v-on="on"
                        />
                      </v-layout>
                    </template>
                    <v-time-picker v-if="showDueTimeDialog" v-model="duedate.starttime" full-width>
                      <v-spacer></v-spacer>
                      <v-btn flat color="primary" @click="showDueTimeDialog = false">{{
                        $t('cancel')
                      }}</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="
                          $refs.starttime.save(duedate.starttime)
                          showDueTimeDialog = false
                          onSelectedDueDate(duedate.end)
                        "
                        >{{ $t('Confirm') }}</v-btn
                      >
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs2 sm1>
                  <div class="caption">&nbsp;</div>
                  <v-btn
                    fab
                    flat
                    small
                    @click="
                      duedate.starttime = null
                      duedate.start = null
                    "
                  >
                    <v-icon>close</v-icon>
                  </v-btn>
                </v-flex>
              </template>

              <v-flex v-if="['nt'].includes(selectedBot.type)" xs12 class="mb-2">
                <div class="caption mb-1 mt-2">Reason *</div>

                <ReasonManage
                  v-model="ticket.reasoning"
                  @onUpdateReasonData="handleUpdateReasonData"
                />

                <input
                  v-model="nt_reason"
                  v-validate="'required'"
                  type="hidden"
                  name="nt_reason"
                  data-vv-as="Reason"
                />

                <div class="form-control" :class="{ 'has-error': errors.has('nt_reason') }">
                  <p v-if="errors.has('nt_reason')" class="text-error">
                    {{ errors.first('nt_reason') }}
                  </p>
                </div>
              </v-flex>
            </v-layout>

            <div class="text-xs-center">
              <v-btn outline color="grey" :loading="loading || loadingTicket" @click="onCancel">
                {{ $t('cancel') }}
              </v-btn>
              <template
                v-if="
                  ($store.state.privilege && $store.state.privilege.update_ticket) ||
                  ['seagull'].includes(selectedBot.theme)
                "
              >
                <v-btn
                  color="primary"
                  depressed
                  :loading="loading || loadingTicket"
                  @click="onSave"
                  >{{ $t('Save') }}</v-btn
                >
              </template>
            </div>
          </div>
          <div v-else>
            <!-- Customize for Next Capital -->
            <NextCapitalAgentApprove :data="dataAgentApprove" @close="onCancel" />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ManageTicket from './ManageTicket.js'
export default {
  mixins: [ManageTicket],

  mounted() {
    this.$validator.pause()
    this.$nextTick(() => {
      this.$validator.errors.clear()
      this.$validator.fields.items.forEach((field) => field.reset())
      this.$validator.fields.items.forEach((field) => this.errors.remove(field))
      this.$validator.resume()
    })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/EditTicket.vue